<template>
  <dropdown class="attachments-dropdown" placement="bottom" title="Attachments">
    <div class="attachments-dropdown__button">
      <i class="ddi ddi-attachment" />
      {{listAttachments.length}}
    </div>
    <template #content>
      <div>
        <ul v-if="hasAttachments">
          <li
            v-for="item in listAttachments"
            :key="`attachment-${item.id}`"
            class="attachments-dropdown__item"
          >
            <a :href="item.url" target="_blank">
              <img :src="getFileTypeIcon(item.type)">
              <span>{{ item.name }}</span>
            </a>
          </li>
        </ul>
      </div>
    </template>
  </dropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { IAttachment } from '@/types/data-objects/attachments'
import { IDynamicObject } from '@/types'

import GoogleDriveIcon from '@/components/item/attachments-list/img/attachment-google-drive.svg'
import PdfIcon from '@/components/item/attachments-list/img/attachment-pdf.svg'
import ExcelIcon from '@/components/item/attachments-list/img/attachment-excel.svg'
import ImageIcon from '@/components/item/attachments-list/img/attachment-image.svg'
import WordIcon from '@/components/item/attachments-list/img/attachment-word.svg'
import ZipIcon from '@/components/item/attachments-list/img/attachment-zip.svg'
import AttachmentIcon from '@/components/item/attachments-list/img/attachment.svg'

export default defineComponent({
  name: 'AttachmentsDropdown',
  props: {
    listAttachments: {
      type: Array as () => IAttachment[],
      default: (): IAttachment[] => [],
    },
  },

  computed: {
    hasAttachments(): boolean {
      return this.listAttachments.length > 0
    },
    fileTypesIcons(): IDynamicObject {
      return {
        googleDrive: GoogleDriveIcon,
        file_pdf: PdfIcon,
        file_img: ImageIcon,
        file_doc: WordIcon,
        file_xls: ExcelIcon,
        file_zip: ZipIcon,
        file: AttachmentIcon,
      }
    },
    listAttachmentsIcon(): any {
      return this.listAttachments.map(item => {
        return {
          ...item,
          icon: this.getFileTypeIcon(item.type),
        }
      })
    },
  },

  methods: {
    getFileTypeIcon(type: string): string {
      return this.fileTypesIcons[type]
    },
  },
})
</script>

<style lang="scss">
.attachments-dropdown {
  max-width: 62px;

  &__button {
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    color: var(--color-text-secondary);
    cursor: pointer;

    .ddi-attachment {
      font-size: 20px;
      color: var(--color-text-third);
    }

    &:hover {
      .ddi-attachment {
        color: var(--color-text-secondary);
      }
    }
  }

  &__item {
    a {
      max-width: 240px;
      display: flex;
      img {
        padding-right: 6px;
      }
      span {
        @include single-line-ellipsis;
      }
    }
  }
}
</style>
